module.exports = __webpack_public_path__ + "img/full7-min.317d6c07.png";